module.exports = __webpack_public_path__ + "static/media/goods.258af95b.png";